import { createSlice } from '@reduxjs/toolkit';
import { LocationCodes } from 'modules/types/LocationCodes';
import { fetchCitiesByCountryCode, fetchCountries } from './thunks';

const initialStateLocationInfo = {
  loading: true,
  data: undefined,
  error: undefined,
};

const initialState: LocationCodes = {
  country: initialStateLocationInfo,
  city: initialStateLocationInfo,
};

export const locationCodesSlice = createSlice({
  name: 'locationCodes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // countries
    builder.addCase(fetchCountries.pending, (state) => {
      state.country = initialState.country;
    });
    builder.addCase(fetchCountries.fulfilled, (state, action) => {
      if (state.country) {
        state.country.loading = false;
        state.country.data = action.payload.country;
      }
    });
    builder.addCase(fetchCountries.rejected, (state, action) => {
      if (state.country) {
        state.country.loading = false;
        state.country.error = action.payload
          ? (action.payload as Error)?.message
          : action.error?.message;
      }
    });

    // cities
    builder.addCase(fetchCitiesByCountryCode.pending, (state) => {
      state.city = initialState.city;
    });
    builder.addCase(fetchCitiesByCountryCode.fulfilled, (state, action) => {
      if (state.city) {
        state.city.loading = false;
        state.city.data = action.payload.city;
      }
    });
    builder.addCase(fetchCitiesByCountryCode.rejected, (state, action) => {
      if (state.city) {
        state.city.loading = false;
        state.city.error = action.payload
          ? (action.payload as Error)?.message
          : action.error?.message;
      }
    });
  },
});

export default locationCodesSlice.reducer;
